// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.active-game h2.title {
  font-weight: 400;
  font-size: 2.2vw;
  color: #3A3A3A;
  margin-bottom: 1.5vw;
}
.active-game .box-container {
  display: flex;
  align-items: center;
  gap: 0.5vw;
}
.active-game .box-container p {
  font-size: 0.94vw;
  font-weight: 400;
  color: #636363;
}
.active-game .gamification {
  box-shadow: none;
  background: transparent;
  min-height: auto;
}
.active-game .gamification .game-list .game-detail .customize span {
  margin: 0 0.6vw;
}
.active-game .gamification .game-list .game-detail button.customize {
  background: transparent;
  border: 0.1vw solid #EE3A24;
  color: #EE3A24;
}
.active-game .gamification .game-list .game-detail button.customize svg path {
  stroke: #EE3A24;
}
.active-game .gamification .details-container.not-selected .img-container:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  z-index: 0;
  cursor: pointer;
}
.active-game .gamification .details-container.not-selected .img-container .play-icon, .active-game .gamification .details-container.not-selected .img-container .title {
  z-index: 1;
}
.active-game .gamification .details-container.not-selected .img-container:hover .play-icon svg {
  filter: invert(54%) sepia(94%) saturate(4765%) hue-rotate(339deg) brightness(87%) contrast(116%);
}
.active-game .gamification .details-container.not-selected .game-title, .active-game .gamification .details-container.not-selected .game-description {
  opacity: 0.7;
}
.active-game .gamification .button2 {
  float: right;
  margin-right: 3.5vw;
  background-color: #EE3A24;
  padding: 0 5vw;
  border-radius: 0.3vw;
}
.active-game .gamification .button2 svg {
  position: relative;
  top: 0.1vw;
  right: -0.25vw;
}

.home-section:has(.active-game) {
  padding-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/style/components/game/ActiveGame.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;AAAR;AAEI;EACI,aAAA;EACA,mBAAA;EACA,UAAA;AAAR;AACQ;EACI,iBAAA;EACA,gBAAA;EACA,cAAA;AACZ;AAEI;EACI,gBAAA;EACA,uBAAA;EACA,gBAAA;AAAR;AACQ;EACI,eAAA;AACZ;AACQ;EACI,uBAAA;EACA,2BAAA;EACA,cAAA;AACZ;AACY;EACI,eAAA;AAChB;AAKgB;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;AAHpB;AAKgB;EACI,UAAA;AAHpB;AAMoB;EACI,gGAAA;AAJxB;AAQY;EACI,YAAA;AANhB;AASQ;EACI,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,oBAAA;AAPZ;AAQY;EACI,kBAAA;EACA,UAAA;EACA,cAAA;AANhB;;AAaA;EACI,iBAAA;AAVJ","sourcesContent":[".active-game{\n    h2.title{\n        font-weight: 400;\n        font-size: 2.2vw;\n        color: #3A3A3A;\n        margin-bottom: 1.5vw;\n    }\n    .box-container{\n        display: flex;\n        align-items: center;\n        gap: .5vw;\n        p{\n            font-size: .94vw;\n            font-weight: 400;\n            color: #636363;\n        }\n    }\n    .gamification{\n        box-shadow: none;\n        background: transparent;\n        min-height: auto;\n        .game-list .game-detail .customize span{\n            margin: 0 .6vw;\n        }\n        .game-list .game-detail  button.customize {\n            background: transparent;\n            border: .1vw solid #EE3A24;\n            color: #EE3A24;\n    \n            svg path{\n                stroke:#EE3A24;\n            }\n        }\n\n        .details-container.not-selected {\n            .img-container{\n                &:after {\n                    content: \"\";\n                    position: absolute;\n                    width: 100%;\n                    height: 100%;\n                    background: rgba(0,0,0,.5);\n                    top: 0;\n                    left: 0;\n                    z-index: 0;\n                    cursor: pointer;\n                }\n                .play-icon,.title{\n                    z-index: 1;\n                }\n                &:hover{\n                    .play-icon svg{\n                        filter: invert(54%) sepia(94%) saturate(4765%) hue-rotate(339deg) brightness(87%) contrast(116%);\n                    }\n                }\n            }\n            .game-title,.game-description{\n                opacity: .7;\n            }\n        }\n        .button2{\n            float: right;\n            margin-right: 3.5vw;\n            background-color: #EE3A24;\n            padding: 0 5vw;\n            border-radius: .3vw;\n            svg{\n                position: relative;\n                top: .1vw;\n                right: -.25vw;\n            \n            }\n        }\n    }\n\n}\n.home-section:has(.active-game){\n    padding-bottom: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
